import React from "react";

function AdminDashboardCard({ icon, bgColor, innerBg, quantity, label }) {
  return (
    <div
      className="flex items-center gap-4 p-5 rounded-lg shadow"
      style={{ backgroundColor: bgColor }}
    >
      <div className="p-4 rounded-md" style={{ backgroundColor: innerBg }}>
        {icon}
      </div>
      <div>
        <h2 className="text-2xl font-bold">{quantity}</h2>
        <p className="text-gray-700">{label}</p>
      </div>
    </div>
  );
}

export default AdminDashboardCard;
